import type {
    SiteAnalyticsSummaryScaffoldConfig,
} from '@client/app/feature-modules/site-analytics/types/site-analytics-summary-scaffold.type';

export const VISITORS_SUMMARY_PAGE_CONFIG: SiteAnalyticsSummaryScaffoldConfig = {
    mode: 'visitors',
    pageHeaderKey: 'siteAnalytics.summary.visitors.header',
    pageSubheaderKey: 'siteAnalytics.summary.visitors.subheader',
    dateRangeLabelKey: 'siteAnalytics.scaffold.dateRange.label',
    emptyStateLabelKey: 'siteAnalytics.summary.shared.emptyState',
    visitorsTechnologySectionTitleKey: 'siteAnalytics.summary.visitors.technologySectionTitle',
    visitorsCards: [
        {
            id: 'devices',
            titleKey: 'siteAnalytics.summary.visitors.cards.devices.title',
            overviewLinkLabelKey: 'siteAnalytics.summary.visitors.cards.devices.overviewLink',
            overviewState: 'base.customer.domain.statistics.visitors.devices',
            chartType: 'doughnut',
        },
        {
            id: 'operatingSystems',
            titleKey: 'siteAnalytics.summary.visitors.cards.operatingSystems.title',
            overviewLinkLabelKey: 'siteAnalytics.summary.visitors.cards.operatingSystems.overviewLink',
            overviewState: 'base.customer.domain.statistics.visitors.os',
            chartType: 'doughnut',
        },
        {
            id: 'browsers',
            titleKey: 'siteAnalytics.summary.visitors.cards.browsers.title',
            overviewLinkLabelKey: 'siteAnalytics.summary.visitors.cards.browsers.overviewLink',
            overviewState: 'base.customer.domain.statistics.visitors.browsers',
            chartType: 'doughnut',
        },
        {
            id: 'screenResolutions',
            titleKey: 'siteAnalytics.summary.visitors.cards.screenResolutions.title',
            overviewLinkLabelKey: 'siteAnalytics.summary.visitors.cards.screenResolutions.overviewLink',
            overviewState: 'base.customer.domain.statistics.visitors.resolutions',
            chartType: 'bubble',
        },
    ],
};
